// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1831) return "static/chunks/bd904a5c-0c077ed8d7735fed.js";
	if (chunkId === 2274) return "static/chunks/51749ec1-00a11b6b2b85a907.js";
	if (chunkId === 9367) return "static/chunks/b536a0f1-4bb8b461d08c3f90.js";
	if (chunkId === 8683) return "static/chunks/0f8af13e-e567043f59acd675.js";
	if (chunkId === 8339) return "static/chunks/8339-454372e9ea1e20e2.js";
	if (chunkId === 8596) return "static/chunks/8596-40684596b84c9ddd.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3524":"2170a4aa","3930":"164f4fb6","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","2340":"b1296ef71b0801a5","3524":"c3d4f254b7bd9a0b","3756":"e3dcfa47bb7b359c","3930":"04bdbcb064f0f52e","4316":"da7517a88118b074","8160":"12ccfaa617568449","8436":"1bcbe559b5a05c18","9839":"97db545449e006dc"}[chunkId] + ".js";
};